import { useState } from "react";
import { useOverview } from "@/lib/useOverview";
import DateRange from "@/components/DateRange";
import WebsiteSection from "@/components/dashboard/Website";
import DeltaBadge from "@/components/DeltaBadge";
import { fmtCompact, fmtNumber } from "@/lib/format";
import { Loader2 } from "lucide-react";

export default function Website() {
  const [range, setRange] = useState(30);
  const { data, isLoading } = useOverview(range);

  if (isLoading || !data) {
    return <div className="grid h-[60vh] place-items-center"><Loader2 className="h-8 w-8 animate-spin text-brand-primary" /></div>;
  }
  const w = data.website;
  const stats = [
    { label: "Website Users", value: fmtNumber(w.users), delta: w.users_delta },
    { label: "Sessions", value: fmtCompact(w.sessions) },
    { label: "Engagement Rate", value: `${w.engagement_rate}%` },
  ];

  return (
    <div className="space-y-8">
      <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Your Website</h1>
          <p className="mt-1 text-muted-foreground">Where your traffic comes from and what it looks at.</p>
        </div>
        <DateRange value={range} onChange={setRange} />
      </header>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl border border-border/60 bg-card p-5 shadow-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">{s.label}</p>
            <div className="mt-2 flex items-end justify-between">
              <p className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">{s.value}</p>
              {s.delta != null && <DeltaBadge value={s.delta} />}
            </div>
          </div>
        ))}
      </div>

      <WebsiteSection website={w} />
    </div>
  );
}
